import { SmallText2 } from 'inpock-ui-react';

import * as S from './styled';

export function CashReceiptFooter() {
  const onClickHomeTax = () => {
    window.open('https://hometax.go.kr', '_blank');
  };

  return (
    <S.Footer>
      <S.Content>
        <SmallText2 color="gray400">*</SmallText2>
        <SmallText2 color="gray400">
          발행방법이 자진 발급인 경우 국세청 홈페이지에서 자진발급 분 사용자 등록을 해야만 소득공제
          등의 혜택을 받을 수 있습니다.
        </SmallText2>
      </S.Content>
      <S.Content>
        <SmallText2 color="gray400">*</SmallText2>
        <SmallText2 color="gray400">
          현금영수증 정보는 배송완료 또는 거래 완료 이후 전달되기 때문에 국세청 사이트에서 즉시
          확인되지 않을 수 있습니다.
        </SmallText2>
      </S.Content>
      <S.Content>
        <SmallText2 color="gray400">*</SmallText2>
        <SmallText2 color="gray400">
          해당 영수증은 조세특례제한법 제 126조 3항에 의거 연말정산 시 소득공제혜택 부여 목적으로
          발행됩니다. (국세청 사이트 회원가입 필요)
        </SmallText2>
      </S.Content>
      <S.Content>
        <SmallText2 color="gray400">*</SmallText2>
        <SmallText2 color="gray400">
          현금 영수증은 결제 완료 후 48시간 내로 국세청에서 확인 작업을 거친 후 최종적으로
          확정됩니다.
        </SmallText2>
      </S.Content>
      <S.Content>
        <SmallText2 color="gray400">*</SmallText2>
        <SmallText2 color="gray400">
          해당 영수증은 국세청 사이트
          <S.ButtonText onClick={onClickHomeTax}>(https://hometax.go.kr)</S.ButtonText>
          에서 조회가 가능합니다.
        </SmallText2>
      </S.Content>
    </S.Footer>
  );
}
